define('drops/drawings/milestone/milestone',['jquery', 'drops/drawings/businessprocessElement'], function ($, BusinessProcessElement) {
    'use strict';

    var defaults = {
        data: {
            text: 'New Milestone',
            size: { x: 200, y: 150 }
        }
    };

    function Milestone(options) {
        BusinessProcessElement.call(this, $('<div/>'), defaults, options);

        this.$text = this.createTextElement();

        this.$element
	        .addClass('boxToBorderSize')
            .addClass('bp-milestone')
            .append(this.$text);
    };

    BusinessProcessElement.extend(Milestone, BusinessProcessElement);

    Milestone.typeName = 'Milestone';

    Milestone.prototype.acceptsFlowConnections = false;

    Milestone.prototype.createTextElement = function () {
        return $('<div/>')
            .text(this.data.text);
    };

    Milestone.prototype.preRender = function () {
        if (!this.editable && this.data.entityId) {
            var self = this;
            this.$element
                .css('cursor', 'pointer')
                .on('click', function () {
                    self.triggerEvent('milestoneClicked', self.data.entityId);
                });
        }

        this.applyPosition();
    };

    return Milestone;
});
